import { FC } from "react";
import Button from "../ui/Button";
import DeleteModal from "../ui/DeleteModal";
import { IAxiosResponse } from "../../interfaces/IAxiosResponse";
import {
  IEntityChangeActionRevertResult,
  IEntityChangeGroup
} from "../../interfaces/endpoints/IEntityChangeLog.types";
import { revertEntityAction } from "../../services/EntityChangeLog.service";
import { revertWarningSentence } from "./revertText";

interface IRevertActionButton {
  group: IEntityChangeGroup;
  onReverted: () => void;
}

// One click undoes everything one action did: every entity it changed goes back to how it was before
// the action, in one transaction. Rows that cannot be undone are reported; the rest still revert.
const RevertActionButton: FC<IRevertActionButton> = ({ group, onReverted }) => {
  const count = group.rowCount;
  const paragraph = [
    `Të gjitha ${count} ndryshimet e këtij veprimi kthehen siç ishin para tij.`,
    "Të dhënat që dikush i ka ndryshuar pas këtij veprimi nuk preken; ato mbeten siç janë tani.",
    "Ky kthim regjistrohet vetë si një veprim i ri.",
    // What the undo does not reach, when one of the changed rows is read outside this product.
    revertWarningSentence(group.revertWarningCode)
  ]
    .filter(Boolean)
    .join(" ");

  const describe = (_: string, result?: IAxiosResponse<IEntityChangeActionRevertResult>): string => {
    onReverted();
    const data = result?.data;
    if (!data) return "Veprimi u kthye mbrapa";
    if (data.skipped.length === 0) return `Veprimi u kthye mbrapa: ${data.reverted} ndryshime`;
    return `${data.reverted} ndryshime u kthyen; ${data.skipped.length} nuk mundën të ktheheshin`;
  };

  return (
    <DeleteModal
      params={group.correlationId}
      handleDelete={revertEntityAction}
      title="Kthe mbrapa gjithë veprimin"
      paragraph={paragraph}
      successMessage="Veprimi u kthye mbrapa"
      errorMessage="Kthimi dështoi; asgjë nuk u ndryshua"
      loadingMessage="Duke kthyer..."
      indicator={<Button className="whitespace-nowrap">Kthe mbrapa veprimin</Button>}
      onSuccess={describe}
    />
  );
};

export default RevertActionButton;
